import React from "react";
import { useLocation } from "react-router-dom";

import { applyStaticSeoMetadata } from "../lib/staticSeoRegistry";

export default function StaticSeoMetadataBoundary() {
  const location = useLocation();

  React.useEffect(() => {
    applyStaticSeoMetadata(location.pathname);
  }, [location.pathname]);

  return null;
}
